;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('ArtCollectionsService', artCollectionsService)

  /* @ngInject */
  function artCollectionsService (ConnectorWebService, CONSTANTS, Utils, UploadService) {
    const service = {
      getCollectionsById,
      getTemplatesById,
      createArtCollection,
      createArtSection,
      updateArtCollection,
      getArtSections,
      archiveArtCollection,
      unarchiveArtCollection,
      highlightArtCollection,
      moveArtCollection,
      getProducts,
      getAll,
      find,
      getHighlightedCollections,
      searchArtCollections,
      notificateMembers,
      getArtCollectionPath,
      updateItemOrder,
      getAllowedGroups,
      getSegmentationInfo,
      bindArtCollectionToCampaign,
      unbindArtCollectionFromCampaign,
      moveMultipleArtCollection,
      archiveMultipleCollections,
      getArtCollectionThumbnail,
      isArtCollectionInsideCampaign,
      hasMaterialsLinkedToCampaign,
      collectionHasExpiration
    }
    return service

    function getAll (top, skip, isRoot, isArchived, isHightlighted, isShowAll) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ALL)

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      url = Utils.fnAddQueryToUrl(url, { isRoot, isArchived, isHightlighted, isShowAll })

      return ConnectorWebService.get(url)
    }

    function find (id, filters) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID, [id])

      if (filters && filters.skipArchived) {
        url = Utils.fnAddQueryToUrl(url, { skipArchived: filters.skipArchived })
      }

      return ConnectorWebService.get(url)
    }

    function getHighlightedCollections (params) {
      const { top, skip, sort, adminView } = params
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_HIGHLIGHTED)

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (sort) {
        url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
      }

      if (adminView) {
        url = Utils.fnAddQueryToUrl(url, { adminView })
      }

      return ConnectorWebService.get(url)
    }

    function getCollectionsById (id, params) {
      const { top, skip, highlighted, search, isArchived, createdAt, templateExpiration, groupId, filterInstagram } = params
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_COLLECTIONS, [id])

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (highlighted) {
        url = Utils.fnAddQueryToUrl(url, { highlighted })
      }

      if (search) {
        url = Utils.fnAddQueryToUrl(url, { search })
      }

      if (isArchived) {
        url = Utils.fnAddQueryToUrl(url, { isArchived })
      }

      if (createdAt) {
        url = Utils.fnAddQueryToUrl(url, { createdAt })
      }

      if (templateExpiration) {
        url = Utils.fnAddQueryToUrl(url, { expirationDate: templateExpiration })
      }

      if (groupId) {
        url = Utils.fnAddQueryToUrl(url, { groupId })
      }

      if (filterInstagram) {
        url = Utils.fnAddQueryToUrl(url, { filterInstagram })
      }

      return ConnectorWebService.get(url)
    }

    function getTemplatesById (id, params) {
      const {
        top,
        skip,
        search,
        groupId,
        formatId,
        artTagIds,
        createdAt,
        isArchived,
        searchMode,
        previewSort,
        startFromId,
        needApproval,
        customizationLevel,
        templateExpiration,
        filterInstagram
      } = params

      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_TEMPLATES, [id])
      url = Utils.fnAddQueryToUrl(url, { formatId, customizationLevel, needApproval, groupId, createdAt, templateExpiration, isArchived })

      if (top || skip) url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      if (search) url = Utils.fnAddQueryToUrl(url, { search })
      if (artTagIds) url = Utils.addQueryStringFromArray(url, 'artTagIds', artTagIds)
      if (searchMode) url = Utils.fnAddQueryToUrl(url, { searchMode })
      if (startFromId && previewSort) url = Utils.fnAddQueryToUrl(url, { startFromId, previewSort })
      if (filterInstagram) url = Utils.fnAddQueryToUrl(url, { filterInstagram })

      return ConnectorWebService.get(url)
    }

    function createArtCollection (payload, cbSuccess, cbError) {
      return UploadService.upload(CONSTANTS.URL_ART_COLLECTIONS_COLLECTION, payload, {}, { cbSuccess, cbError })
    }

    function createArtSection (payload) {
      return ConnectorWebService.post(CONSTANTS.URL_ART_COLLECTIONS_SECTION, payload)
    }

    function updateArtCollection (id, payload, cbSuccess, cbError) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_COLLECTION_ID, [id])
      return UploadService.upload(url, payload, {}, { method: 'PUT', cbSuccess, cbError })
    }

    function getArtSections (params) {
      const { top, skip, allCollections } = params

      let url = CONSTANTS.URL_ART_COLLECTIONS_SECTIONS

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (allCollections) {
        url = Utils.fnAddQueryToUrl(url, { allCollections })
      }

      return ConnectorWebService.get(url)
    }

    function archiveArtCollection (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_ARCHIVE, [id])

      if (window.__DeskfyObserver__) {
        window.__DeskfyObserver__['archived-collection'] = id
      }

      return ConnectorWebService.put(url)
    }

    function unarchiveArtCollection (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_UNARCHIVE, [id])

      return ConnectorWebService.put(url)
    }

    function archiveMultipleCollections (collectionIds) {
      const url = CONSTANTS.URL_ART_COLLECTIONS_ARCHIVE_MULTIPLE

      return ConnectorWebService.put(url, { collectionIds })
    }

    function bindArtCollectionToCampaign (params = {}) {
      const { assetId, selectedCampaign } = params

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_BIND_COLLECTIONS, [assetId])
      return ConnectorWebService.put(url, { campaignId: selectedCampaign })
    }

    function unbindArtCollectionFromCampaign (params) {
      const { campaignId, artCollectionId } = params
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_UNBIND_COLLECTIONS, [artCollectionId])

      if (campaignId) {
        url = Utils.fnAddQueryToUrl(url, { campaignId })
      }

      return ConnectorWebService.put(url)
    }

    function highlightArtCollection (id, highlighted, newParentId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_HIGHLIGHT, [id])

      return ConnectorWebService.put(url, { highlighted, newParentId })
    }

    function moveArtCollection (id, toId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_MOVE, [id])

      return ConnectorWebService.put(url, { artCollectionId: toId })
    }

    function moveMultipleArtCollection (ids, toId) {
      const url = CONSTANTS.URL_ART_COLLECTIONS_MOVE_MULTIPLE

      return ConnectorWebService.put(url, { collectionIds: ids, newParentId: toId })
    }

    function getProducts (collectionId, params) {
      const { top, skip } = params
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_PRODUCTS, [collectionId])

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      return ConnectorWebService.get(url)
    }

    function searchArtCollections (term, top, skip, isRoot, isShowAll, filters) {
      let url = CONSTANTS.URL_ART_COLLECTIONS_SEARCH
      const filtersObj = filters || {}
      const { isArchived, createdAt, templateExpiration, groupId, createdAtStart, templateExpirationStart, createdAtEnd, templateExpirationEnd } = filtersObj

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (isArchived) {
        url = Utils.fnAddQueryToUrl(url, { isArchived })
      }

      if (createdAt) {
        url = Utils.fnAddQueryToUrl(url, { createdAt })
      }

      if (templateExpiration) {
        url = Utils.fnAddQueryToUrl(url, { expirationDate: templateExpiration })
      }

      if (groupId) {
        url = Utils.fnAddQueryToUrl(url, { groupId })
      }

      if (createdAtStart && createdAtEnd) {
        url = Utils.fnAddQueryToUrl(url, { createdAtStart, createdAtEnd })
      }

      if (templateExpirationStart && templateExpirationEnd) {
        url = Utils.fnAddQueryToUrl(url, { expirationStart: templateExpirationStart, expirationEnd: templateExpirationEnd })
      }

      url = Utils.fnAddQueryToUrl(url, { term, isRoot, isShowAll })

      return ConnectorWebService.get(url)
    }

    function notificateMembers (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_NOTIFICATE, [id])
      return ConnectorWebService.post(url)
    }

    function getArtCollectionPath (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_PATH, [id])
      return ConnectorWebService.get(url)
    }

    function updateItemOrder (id, newIndex) {
      if (!id) {
        throw new Error('Id cannot be null')
      }

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_ORDER, [id])
      return ConnectorWebService.put(url, { order: newIndex })
    }

    function getAllowedGroups (baseCollectionId) {
      let url = CONSTANTS.URL_ART_COLLECTIONS_ALLOWED_GROUPS

      if (baseCollectionId) {
        url = Utils.fnAddQueryToUrl(url, { baseCollectionId })
      }

      return ConnectorWebService.get(url)
    }

    function getSegmentationInfo (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_SEGMENTATION, [id])

      return ConnectorWebService.get(url)
    }

    function getArtCollectionThumbnail (id, updatedAt) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_THUMBNAIL, [id])
      return updatedAt ? Utils.fnAddQueryToUrl(url, { cache: updatedAt }) : url
    }

    function isArtCollectionInsideCampaign (artCollectionId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_INSIDE_CAMPAIGN, [artCollectionId])
      return ConnectorWebService.get(url)
    }

    function hasMaterialsLinkedToCampaign (artCollectionId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_HAS_LINKED_MATERIALS_IN_CAMPAIGN, [artCollectionId])
      return ConnectorWebService.get(url)
    }

    function collectionHasExpiration (artCollectionId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_HAS_EXPIRATION, [artCollectionId])
      return ConnectorWebService.get(url)
    }
  }
})()
